import { Empty, Modal, Spin } from 'antd'
import CustomTag from 'components/CustomTag'
import Pagination from 'components/Pagination'
import {
  DivWrapper,
  FlexWrap,
  RoleColComment,
  RoleColHead,
  RowNumberDriveAlignCenter,
  RowNumberDriveAlignCenterItem,
  UpTag,
  Wrapper,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import UpwardGreenArrowIcon from 'components/icons/UpwardGreenArrowIcon'
import ActionDropdown from 'modules/Roles/Partials/RolesTable/ActionDropdown/index'
import CandidateRankingDrawer from 'modules/Roles/Partials/RolesTable/CandidateRankingDrawer'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import { EmptyWrapper } from 'modules/Roles/Style/style'
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { getDay } from 'utils/getDay'
import CloseRoleDrawer from 'components/CloseRolePopup'
import ApprovedModelIcon from 'components/icons/ApprovedModelIcon'
import { POPUP_CONFIGS } from '../../../../utils/const'

const { confirm } = Modal

const RolesTable = ({
  setPageNum,
  jobsList,
  closeApplication,
  duplicateRole,
  deleteRole,
  setSortBy,
  setOrderBy,
  pageLimit,
  getSingleRoleData,
  roleTableloading,
  setEditRoleOnView,
  permittedCruds,
  pageNum,
  getRoleData,
  currentJobId,
}) => {
  const [loading, setLoading] = useState(false)
  const [rankingDrawer, setRankingDrawer] = useState(false)
  const [selectedRoleId, setSelectedRoleId] = useState('')
  const [allowToUpdateRanking] = useState(false)
  const [popupConfig, setPopupConfig] = useState(null)

  let isSorting = true
  const navigate = useNavigate()

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
      setPageNum(0)
    } else {
      setOrderBy('')
      setSortBy('')
      setPageNum(0)
    }
  }

  const onActionsClick = (jobId, action) => {
    if (action == 'close') {
      confirm({
        title: 'Close application?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: () => {
          closeApplication(jobId, setLoading)
        },
      })
    }
    if (action == 'duplicate') {
      confirm({
        title: 'Duplicate Role?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: async () => {
          let { status } = await duplicateRole(jobId, setLoading)
          if (status >= 200 && status < 300) {
            getRoleData()
          }
        },
      })
    }
    if (action == 'delete') {
      confirm({
        title: 'Delete Role?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: async () => {
          let { status } = await deleteRole(jobId, setLoading, setPageNum)
          if (status >= 200 && status < 300) {
            getRoleData()
          }
        },
      })
    }
  }

  const onPageChange = value => {
    setPageNum(value - 1)
  }

  const onEditClick = async (jobId, roleStatus, roleData) => {
    try {
      const { status } = await getSingleRoleData(0, jobId)

      if (status) {
        if (status >= 200 && status < 300) {
          if (!roleData?.republishedDate) {
            if (roleStatus == 'active') {
              setEditRoleOnView(true)
            }
            navigate(`/roles/edit-role/${jobId}?CS=${roleData?.currentState}`)
          } else {
            handleThirdTimeEditRole(jobId, roleStatus)
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch role data:', error)
    }
  }

  const onViewClick = async jobId => {
    let { status } = await getSingleRoleData(0, jobId)

    if (status >= 200 && status < 300) {
      navigate(`${jobId}/view-roleChart`)
    }
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const tabValues = [
    { label: 'Placement', value: 'PLACEMENT' },
    { label: 'Internship', value: 'INTERNSHIP' },
    { label: 'Internship + PPO', value: 'INTERNSHIP+PPO' },
    { label: 'Internship + PPO', value: 'INTERNSHIP_PPO' },
    { label: 'Apprenticeship', value: 'APPRENTICESHIP' },
    { label: 'Gigs', value: 'GIGS' },
  ]
  
     const checkJobCategory = data => {
    let result = tabValues.find(item => item.value == data)
    return result?.label
  }
  const handleThirdTimeEditRole = (jobId, roleStatus) => {
    return new Promise(resolve => {
      setPopupConfig({
        ...POPUP_CONFIGS.CREATE_NEW_GROUP,
        description: (
          <span>
            This application has already been edited once. You can now only
            modify the end date and time.
          </span>
        ),
        icon: ApprovedModelIcon,
        onApprove: async () => {
          if (roleStatus == 'active') {
            setEditRoleOnView(true)
          }
          navigate(`/roles/edit-role/${jobId}`)
        },
        onClose: () => {
          setPopupConfig(null)
          resolve()
        },
      })
    })
  }
  const columns = [
    {
      title: 'Roles',
      dataIndex: 'tittle',
      width: 300,
      sorter: isSorting,
      render: (text, data) => (
        <DivWrapper maxwidth={'300px'}>
          <FlexWrap gap="5px">
            <RoleColHead>{text}</RoleColHead>
            <RoleColHead>
              {!!data?.duplicatedJobId && (
                <CustomTag colorType="grey" message="Copy" />
              )}
            </RoleColHead>
          </FlexWrap>
          <RoleColComment>
            {checkJobCategory(data?.jobCategory)} -{' '}
            {`${data?.jobType?.split('_')?.join(' ')?.toLowerCase()}`}
          </RoleColComment>
        </DivWrapper>
      ),
    },
    {
      title: 'Colleges',
      dataIndex: 'colleges',
      sorter: isSorting,
      align: 'center',
      render: (text, data) => (
        <RowNumberDriveAlignCenter>
          {data?._count?.jobRoleInstituteMap}
        </RowNumberDriveAlignCenter>
      ),
    },
    {
      title: 'Candidates',
      sorter: isSorting,
      dataIndex: 'candidates',
      align: 'center',
      render: (_, { _count, lastDayStudentCount = 0 }) => (
        <RowNumberDriveAlignCenterItem>
          <RowNumberDriveAlignCenter>
            {_count?.jobRoleStudentMap}
          </RowNumberDriveAlignCenter>
          <UpTag centerVertically>
            <RowNumberDriveAlignCenter>
              <b>{lastDayStudentCount ?? 0}</b>
            </RowNumberDriveAlignCenter>

            <UpwardGreenArrowIcon />
          </UpTag>
        </RowNumberDriveAlignCenterItem>
      ),
    },
    {
      title: 'status',
      dataIndex: 'status',
      align: 'center',
      sorter: isSorting,
      render: status => <RoleStatus status={status} />,
    },
    {
      title: 'Posted On',
      dataIndex: 'postedDate',
      sorter: isSorting,
      align: 'center',
      render: date => {
        const isValidDate = date && !isNaN(new Date(date).getTime())
        const formattedDate = isValidDate
          ? new Date(date).toLocaleDateString('en-GB', { timeZone: 'UTC' })
          : '-'

        return (
          <RowNumberDriveAlignCenter>{formattedDate}</RowNumberDriveAlignCenter>
        )
      },
    },
    {
      title: 'Action',
      dataIndex: 'id',
      width: 120,
      hidden: !permittedCruds?.includes('VIEW'),

      render: (id, data) => (
        <ActionDropdown
          jobId={id}
          text={'view'}
          data={data}
          onEditClick={onEditClick}
          onActionsClick={onActionsClick}
          onViewClick={onViewClick}
          setRankingDrawer={setRankingDrawer}
          setSelectedRoleId={setSelectedRoleId}
          permittedEvents={permittedCruds}
        />
      ),
    },
  ].filter(item => !item.hidden)

  return (
    <>
      {popupConfig && (
        <CloseRoleDrawer
          description={<>{popupConfig.description}</>}
          Textdescription={'All other fields will remain locked.'}
          Icon={popupConfig.icon}
          showDrawer={true}
          setShowDrawer={() => setPopupConfig(null)}
          onCloseClick={popupConfig.onClose}
          onApprove={popupConfig.onApprove}
          closeText={popupConfig.closeText}
          YesText={popupConfig.yesText}
          closeButtonHeight={popupConfig.closeButtonHeight}
          closeButtonWidth={popupConfig.closeButtonWidth}
          yesButtonHeight={popupConfig.yesButtonHeight}
          yesButtonWidth={popupConfig.yesButtonWidth}
        />
      )}
      <Wrapper>
        <StyledTable
          id={'mode'}
          columns={columns}
          pagination={false}
          dataSource={jobsList?.result}
          onChange={handleSort}
          loading={roleTableloading || loading}
          locale={{
            emptyText: (
              <EmptyWrapper center isSpin={!roleTableloading}>
                {roleTableloading ? (
                  <Spin />
                ) : (
                  <Empty description={'No roles Found'} />
                )}
              </EmptyWrapper>
            ),
          }}
        />
        <Pagination
          onChange={onPageChange}
          totalPages={jobsList?.totalPage * 10}
          pageSize={pageLimit}
          current={pageNum + 1}
        />
      </Wrapper>
      {rankingDrawer && (
        <CandidateRankingDrawer
          openDrawer={rankingDrawer}
          setOpenDrawer={setRankingDrawer}
          selectedRoleId={selectedRoleId}
          allowToUpdate={allowToUpdateRanking}
        />
      )}
    </>
  )
}

export default RolesTable
